// src/app/auth/_guards/login-redirect.guard.ts
import { Injectable } from '@angular/core';
import { ActivatedRoute, CanActivate, Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { CrewSelfService } from 'src/app/shared/services/crew-self.service';
import { jwtDecode } from 'jwt-decode';
import { StateData } from '../auth.component';

@Injectable()
export class LoginRedirectGuard implements CanActivate {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly _storageService: StorageService,
    private readonly crewSelfService: CrewSelfService,
    private readonly route: ActivatedRoute,
  ) { }

 canActivate(): boolean {
  console.log('AuthService: authGuard called');
  const encAccessToken: any = this._storageService.getDataFromStorage('access_token');
  console.log('Encrypted Access Token:', encAccessToken);

  const decrypted = encAccessToken ? this.crewSelfService.decryptData(encAccessToken) : {};
  console.log('Decrypted Access Token:', decrypted);


  const stateParam = new URLSearchParams(window.location.search).get('state');
  if (stateParam) {
    const state_data = jwtDecode<StateData>(stateParam);
    const platform = state_data.platform;
    if (platform === 'native') {
      console.log('Platform is native from state - skip redirect');
      return true;
    }
  }

  if (decrypted?.access_token) {
    this.router.navigate(['/home']);
    return false;
  }

  return true;
}

}
